// src/components/shared/forms/specialized/AddressInput.jsx
import React from 'react';
import { TextInput, SelectInput } from '../FormComponents';

export const AddressInput = ({ value = {}, onChange, disabled = false }) => {
  const handleChange = (field, fieldValue) => {
    onChange({
      ...value,
      [field]: fieldValue
    });
  };

  const countryOptions = [
    { value: 'ZA', label: 'South Africa' },
    { value: 'US', label: 'United States' },
    { value: 'GB', label: 'United Kingdom' }
  ];

  return (
    <div className="space-y-3">
      <TextInput
        value={value.street || ''}
        onChange={(val) => handleChange('street', val)}
        placeholder="Street address"
        disabled={disabled}
      />
      
      <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
        <TextInput
          value={value.city || ''}
          onChange={(val) => handleChange('city', val)}
          placeholder="City"
          disabled={disabled}
        />
        
        <TextInput
          value={value.state || ''}
          onChange={(val) => handleChange('state', val)}
          placeholder="State/Province"
          disabled={disabled}
        />
        
        <TextInput
          value={value.zipCode || ''}
          onChange={(val) => handleChange('zipCode', val)}
          placeholder="ZIP/Postal Code"
          disabled={disabled}
        />
      </div>
      
      <SelectInput
        value={value.country || 'ZA'}
        onChange={(val) => handleChange('country', val)}
        options={countryOptions}
        disabled={disabled}
      />
    </div>
  );
};